<app-loading-indicator [isLoading]="isLoading"></app-loading-indicator>

@if (!isLoading) {
  <div class="projectable-form-wrapper">
    <lib-form-header
      [data]="{}"
      [title]="'Potential Conflicts'"
      [showHeaderToggle]="false"
      [showHeaderButton]="false"
      (actionRequested)="headerActionRequested($event)"
    ></lib-form-header>
    <div class="projectable-form-container service-policy-conflict-details-container">
      <app-ui-conflict-details [data]="pageData" variant="service-policy"></app-ui-conflict-details>

      @if (hasMoreIdentities || isLoadingMore) {
        <div #loadMoreTrigger class="policy-conflict-load-more">
          @if (isLoadingMore) {
            <div class="policy-conflict-load-more-status">Loading more affected identities...</div>
          } @else {
            <div class="policy-conflict-load-more-status">More affected identities will load as you scroll.</div>
            <button class="policy-conflict-load-more-button" type="button" (click)="loadMore()">
              Load more identities
            </button>
          }
        </div>
      }
    </div>
  </div>
}
